import { Component, Prop, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";

// External components
import ModalBase from "../modalBase/modalBase";
import DocumentMultiselectInput from "../multiselectInput/documentMultiselectInput/documentMultiselectInput";

@Component({ components: { ModalBase, DocumentMultiselectInput } })
export default class ModalAddDocument extends Vue {
  @Prop({ default: false }) isActive;

  @Action action_updateNormalUserInformation;

  isLoading = false;

  documentTypes = ["cc", "ce"];

  userForm = {
    document_type: "cc",
    document_number: "",
  };

  get isMissingDocument() {
    const { document_type, document_number } = this.userForm;
    return !document_type || !document_type.length || !document_number || !document_number.length;
  }

  async updateUserDocumentInfo() {
    const { document_type, document_number } = this.userForm;
    const payload = {
      normal_user: {
        document_type,
        document_number,
      },
    };
    try {
      this.isLoading = true;
      await this.action_updateNormalUserInformation(payload);
      this.$emit("modal-close");
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Ocurrió un error al intentar actualizar la información del usuario. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
    this.isLoading = false;
  }
}
